import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom-v5-compat';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useOnImportFinished } from '../../../../components/csv-import/data/hooks/use-on-import-finished';
import { ImportType } from '../../../../components/csv-import/data/types/import-type';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { ScanToReceiveDrawer } from '../../../../components/scan-to-receive/scan-to-receive-drawer';
import { useInventoryReceivingFeatureGate } from '../../../../feature-gates/use-inventory-receiving-feature-gate';
import { useModal } from '../../../../hooks/use-modal';
import messages from '../../messages';
import { useInventoryContext } from '../inventory-context';

export const ScanToReceiveButton = () => {
  const { open, isOpen, close } = useModal();

  const { inventoryWarehouseId } = useParams();

  const { refreshGridData } = useInventoryContext();

  const { isFeatureEnabled: isInventoryReceivingEnabled } = useInventoryReceivingFeatureGate();

  useOnImportFinished(ImportType.scanToReceive, refreshGridData);

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={!isInventoryReceivingEnabled}
        disabledTooltipMessage={<FormattedMessage {...messages.scanToReceiveButtonDisabledTooltip} />}
        onClick={open}
        theme={THEME_CONSTANTS.tertiary}
      >
        <FormattedMessage {...messages.scanToReceiveButton} />
      </Button>
      {isOpen && <ScanToReceiveDrawer defaultWarehouseId={inventoryWarehouseId} onClose={close} />}
    </>
  );
};
